import { memo } from "react";
import { DocumentViewerProps } from "../document-viewer.interface";
import * as React from "react";
import { Dialog, DialogContent, Box, Typography } from "@material-ui/core";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import { useImageViewerStyles } from "./image-viewer.style";

export const ImageViewer = memo((props: DocumentViewerProps) => {
    const classes = useImageViewerStyles();
    const [imageError, setImageError] = React.useState(false);
    return <Dialog 
    fullScreen
    open={props.open} 
    onClose={props.onClose} 
    maxWidth="lg" 
    fullWidth 
    PaperProps={{ style: { display: 'flex', flexDirection: 'column', maxHeight: '100vh' } }}>
                <MuiDialogTitle disableTypography className={classes.root}>
                    <Typography variant="h6">Viewing Document {props.name}</Typography>
                    {props.onClose ? (
                        <IconButton id={`${props.domId}-close`} aria-label="close" className={classes.closeButton} onClick={props.onClose}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </MuiDialogTitle>
                <DialogContent className={classes.imageContainer}>
                    {imageError ? (
                        <Box display="flex" minHeight={300} padding={"16px 24px"}>
                            <Typography>Failed to load image file.</Typography>
                        </Box>
                    ) : (
                        props.fileContent ? (
                        <Box className={classes.imageBox}>
                            <img
                                src={URL.createObjectURL(props.fileContent)}
                                alt={props.name}
                                className={classes.image}
                                onError = {() => setImageError(true)}
                            />
                        </Box>
                        ) : (
                        <Box display="flex" minHeight={300} padding={"16px 24px"}>
                            <Typography>No image available.</Typography>
                        </Box>
                        )
                    )}
                </DialogContent>
            </Dialog>;
});
